import _ from 'lodash';
import React from 'react';
import {
  submit,
  formValueSelector,
  isSubmitting,
  resetSection
} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import {Totals, Buttons, DraftInvoiceCreateForm} from './components';

import {fetchXeroAccounts, fetchXeroTaxRates} from 'ducks/tenancy';
import {fetchBooking, MODALS} from 'ducks/bookings';
import {composeActions} from 'ducks/common';

import './styles.css';

class DraftInvoiceCreateModal extends React.Component<any> {
  state = {
    lineAmount: 0.0
  };

  componentDidMount() {
    const {locationRef} = this.props.data;

    const fetchXeroAccountsExtraAction = this.props.storeDataExtraActions(
      data => ({
        xeroAccounts: data
      })
    );
    this.props.fetchXeroAccounts(
      {location: locationRef},
      fetchXeroAccountsExtraAction
    );
  }

  buildXeroTaxRatesFilter = ({accountClass}) => ({
    accountClass: accountClass,
    location: this.props.locationRef
  });

  fetchXeroTaxRatesForAccount = ({accountClass}) => {
    const fetchXeroTaxRatesExtraAction = this.props.storeDataExtraActions(
      data => ({
        xeroTaxRates: data
      })
    );

    this.props.fetchXeroTaxRates(
      {filters: this.buildXeroTaxRatesFilter({accountClass})},
      fetchXeroTaxRatesExtraAction
    );
  };

  triggerFormSubmit = () => {
    this.props.submit('createDraftInvoice');
  };

  onUnitPriceChange = event => {
    const unitPrice = event.target.value;
    const {quantityValue} = this.props.data.form;

    const lineAmount = quantityValue * unitPrice;

    this.setState({
      lineAmount: lineAmount
    });
  };

  onQuantityChange = event => {
    const value = event.target.value;
    const {unitPriceValue} = this.props.data.form;

    const lineAmount = value * unitPriceValue;

    this.setState({
      lineAmount: lineAmount
    });
  };

  getSubmitExtraActions = () => {
    const {bookingId, locationRef, scheduleType, tenancyId} = this.props.data;

    const delayedExtraActions = this.props.delayExtraActions({
      tenancyId,
      scheduleType
    });

    return [
      ...this.props.closeModalExtraActions,
      ...this.props.refetchExtraActions({scheduleType, tenancyId}),
      () => composeActions(delayedExtraActions),
      () => fetchBooking({bookingId, locationRef})
    ];
  };

  render() {
    const {
      data: {
        form: {submitting, subTotalVat},
        locationRef,
        scheduleType,
        primaryTenant,
        booking,
        xeroAccounts,
        xeroTaxRates,
        scheduleId
      }
    } = this.props;

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="DraftInvoiceCreateModal"
        type={Modal.LARGE}>
        <Modal.Header>
          <h3>Create a Draft Invoice</h3>
          <div className="subHeader">To {primaryTenant.fullName}</div>
        </Modal.Header>
        <Modal.Body>
          <DraftInvoiceCreateForm
            locationRef={locationRef}
            submitExtraActions={this.getSubmitExtraActions}
            scheduleType={scheduleType}
            scheduleId={scheduleId}
            xeroAccounts={xeroAccounts || []}
            xeroTaxRates={xeroTaxRates || []}
            storeDataExtraActions={this.props.storeDataExtraActions}
            booking={booking}
            fetchXeroTaxRatesForAccount={this.fetchXeroTaxRatesForAccount}
            lineAmount={this.state.lineAmount}
            onUnitPriceChange={this.onUnitPriceChange}
            onQuantityChange={this.onQuantityChange}
          />
          <Totals subTotal={this.state.lineAmount} subTotalVat={subTotalVat} />
        </Modal.Body>
        <Modal.Footer>
          <Buttons
            triggerSubmit={this.triggerFormSubmit}
            submitting={submitting}
            onClose={this.props.closeModal}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

const selector = formValueSelector('createDraftInvoice');
const mapStateToModalData = state => {
  const xeroTaxRateValue = selector(state, 'xeroTaxRate');

  return {
    form: {
      quantityValue: selector(state, 'quantity'),
      unitPriceValue: selector(state, 'unitPrice'),
      xeroTaxRateValue,
      subTotalVat: Number(_.get(xeroTaxRateValue, 'object.effectiveRate', 0)),
      submitting: isSubmitting('createDraftInvoice')(state)
    }
  };
};

const mapDispatchToProps = {
  submit,
  fetchXeroAccounts,
  fetchXeroTaxRates,
  resetSection
};

export default withModal(
  MODALS.CREATE_DRAFT_INVOICE,
  mapStateToModalData,
  mapDispatchToProps
)(DraftInvoiceCreateModal);
